import styled from "styled-components";
import { darkGray } from "../../styles/colors";

export const Wrapper = styled.div`
  color: ${darkGray};
  font-style: italic;
  text-align: center;
`;
